var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControlBarLike = function SvgIconControlBarLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 33.816 30.928"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M18.072.871c2.274-2.158 5.946.011 5.166 3.041v.004l-1.44 5.53 6.672-.038c3.832-.044 6.431 3.881 4.9 7.393L28.51 27.955a4.95 4.95 0 0 1-4.539 2.973H12.776c-.8 0-1.556-.187-2.227-.518a1.4 1.4 0 0 1-.549.112H3.4a3.4 3.4 0 0 1-3.4-3.4v-14A3.4 3.4 0 0 1 3.4 9.72h5.353q.054-.056.11-.11zM7.74 12.521H3.4a.6.6 0 0 0-.6.6v14a.6.6 0 0 0 .6.6h4.683a5 5 0 0 1-.343-1.83zm13.023-8.293c.214-.977-.98-1.63-1.686-.92l-8.285 8.335a.8.8 0 0 0-.25.583V25.89a2.236 2.236 0 0 0 2.234 2.237h11.196c.855 0 1.629-.507 1.972-1.291l4.858-11.153c.72-1.652-.504-3.497-2.302-3.474h-.01l-8.241.04a1 1 0 0 1-.981-1.215z",
    clipRule: "evenodd"
  })));
};
export default SvgIconControlBarLike;